import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { Skeleton } from "@/components/ui/skeleton";
import type { ReactElement } from "react";

export function DetailPageSkeleton(): ReactElement {
  return (
    <CenteredLayout variant={CenteredLayoutVariant.Wide}>
      <header className="flex min-w-0 items-center gap-4">
        <Skeleton className="size-12 shrink-0 rounded-lg" />
        <div className="flex flex-col gap-2">
          <Skeleton className="h-7 w-48" />
          <Skeleton className="h-4 w-32" />
        </div>
      </header>

      <div className="mt-2 flex flex-col gap-6">
        <div className="flex gap-2">
          <Skeleton className="h-9 w-28" />
          <Skeleton className="h-9 w-28" />
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-3">
          <Skeleton className="h-64 w-full rounded-lg" />
        </div>
      </div>
    </CenteredLayout>
  );
}
